import { DayPortion } from '../types/time-off-request';

/** Minutes per working day used for the client-side requested-days estimate. */
export const MINUTES_PER_WORKING_DAY = 480;

/** Minimal day shape needed to weigh a request day. */
interface RequestedDay {
  isWorkingDay: boolean;
  portion: DayPortion;
  minutes?: number;
}

/** Fractional-day weight contributed by a single day's portion. */
export const portionToDayFraction = (portion: DayPortion, minutes: number | undefined): number => {
  switch (portion) {
    case DayPortion.Full:
      return 1;
    case DayPortion.Half:
      return 0.5;
    case DayPortion.Quarter:
      return 0.25;
    case DayPortion.Hourly:
      return (minutes ?? 0) / MINUTES_PER_WORKING_DAY;
    default:
      return 0;
  }
};

/**
 * Sums the requested days across working days for the live balance preview,
 * rounded to two decimals for display parity with the balance card. The
 * authoritative `totalDays` still comes from the backend on submit.
 */
export const calculateRequestedDays = (days: RequestedDay[]): number => {
  const total = days
    .filter(day => day.isWorkingDay)
    .reduce((sum, day) => sum + portionToDayFraction(day.portion, day.minutes), 0);
  return Math.round(total * 100) / 100;
};
